import { useEffect, useState } from 'react'
import { supabase } from '@/integrations/supabase/client'
import { useAuth } from '@/contexts/AuthContext'
import { getLimite } from '@/lib/planLimits'

interface PlanUsage {
  avaliacoesUsadas: number
  limite: number
  limiteAtingido: boolean
  loading: boolean
}

export function usePlanUsage(): PlanUsage {
  const { loja } = useAuth()
  const [avaliacoesUsadas, setAvaliacoesUsadas] = useState(0)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!loja?.id) {
      setLoading(false)
      return
    }

    async function fetchCount() {
      setLoading(true)
      try {
        const start = new Date()
        start.setDate(1)
        start.setHours(0, 0, 0, 0)

        const { count } = await supabase
          .from('avaliacoes')
          .select('id', { count: 'exact', head: true })
          .eq('loja_id', loja!.id)
          .gte('created_at', start.toISOString())

        setAvaliacoesUsadas(count ?? 0)
      } finally {
        setLoading(false)
      }
    }

    fetchCount()
  }, [loja?.id])

  const limite = getLimite(loja?.plano ?? 'basico')
  const limiteAtingido = avaliacoesUsadas >= limite

  return { avaliacoesUsadas, limite, limiteAtingido, loading }
}
